export default {
	colors: {
		color1: '#50b778',
		color2: '#0072ac',
		textColor: '#184377'
	},
	healthcareFAQ: [
		{
			id: 1,
			side1: "How much does the pre-tax medical plan cost?",
			// side2: "<p><span>Employee:</span> $60.45/pay period</p><p><span>With spouse:</span> $322.81/pay period</p><p><span>With child(ren):</span> $231.53/pay period</p><p><span>Family:</span> $433.04/pay period</p>",
			side2: "<p><span>Family Coverage:</span> $501.56/pay period</p><p><span>Employee/Child(ren):</span> $261.69/pay period</p><p><span>Employee/Spouse:</span> $305.30/pay period</p><p><span>Employee Only:</span> $65.42/pay period</p>",
			icon: "benefits.chippy"
		},{
			id: 2,
			side1: "What’s the deductible on the medical plan?",
			side2: "<p>$500, but regular check-ups only have a copay</p>",
			icon: "benefits.rufus"
		},{
			id: 3,
			side1: "Where can I find the list of in-network providers, compare prescription prices, and find more information on the medical plan?",
			side2: "<p><a href=\"http://mycigna.com\" target=\"_blank\" rel=\"noopener noreferrer\">mycigna.com</a> (but only if you're already signed up for the plan)</p>",
			icon: "benefits.bert"
		},{
			id: 4,
			side1: "Where can I check the provider list if I'm not signed up yet?",
			side2: "<p><a href=\"http://hcpdirectory.cigna.com/web/public/providers\" target=\"_blank\" rel=\"noopener noreferrer\">hcpdirectory.cigna.com/web/public/providers</a> (Select <strong>Open Access Plus</strong> under \"select a plan\")</p>",
			icon: "benefits.rez"
		},{
			id: 5,
			side1: "How much does the pre-tax dental plan cost?",
			side2: "<p><span>Employee:</span> $2.91/pay period</p><p><span>With spouse:</span> $13.97/pay period</p><p><span>With child(ren):</span> $14.65/pay period</p><p><span>Family:</span> $26.39/pay period</p>",
			icon: "benefits.turd"
		},{
			id: 6,
			side1: "Where can I find providers or more info for the dental plan?",
			side2: "<p><a href=\"http://deltadentalva.com/subscribers.aspx\" target=\"_blank\" rel=\"noopener noreferrer\">deltadentalva.com/<br>subscribers.aspx</a></p>",
			icon: "benefits.marx"
		},{
			id: 7,
			side1: "How do I check my FSA balance or submit a claim?",
			side2: "<p><a href=\"http://www.tasconline.com\" target=\"_blank\" rel=\"noopener noreferrer\">www.tasconline.com</a></p>",
			icon: "benefits.zora"
		},{
			id: 8,
			side1: "What's the maximum amount I can put in my FSA?",
			side2: "<p>$2,550 for medical and $5,000 for dependent care</p>",
			icon: "benefits.mrMoneyBags"
		}
	],
	paidTimeOff: [
		{
			id: 1,
			content: "<p>PTO accrues per pay period and includes vacation and sick time.</p><p>Talk to your manager about sick day procedures (preferably before you get sick).</p>"
		},{
			id: 2,
			content: "<p>When taking PTO, request it by creating a calendar invite for your supervisor and/or project manager(s) in Outlook.</p>"
		},{
			id: 3,
			content: "<p>Talk to your project manager about project-specific PTO protocols.</p>"
		},{
			id: 4,
			content: "<p>Don't forget to set an automatic away message on your email when you're on PTO!</p>"
		},{
			id: 5,
			content: "<p>You can carry over up to 80 hours of PTO from year to year, but anything above that is use or lose.</p><p>Take a vacation \u2014 it's good for you!</p>"
		},{
			id: 6,
			content: "<p>Karen will send you a handy spreadsheet you can use to track your PTO.</p>"
		}
	]
};



// WEBPACK FOOTER //
// ./src/data/Benefits.js